var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKakaoPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.37 21.42h-20.76c-4.1 0-7.42-3.32-7.42-7.42s3.32-7.42 7.42-7.42h20.79c4.1 0 7.42 3.32 7.42 7.42s-3.34 7.42-7.44 7.42",
    fill: "#fbeb4f",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.51 10.14c-2.23 0-4.04 1.42-4.04 3.19 0 1.13.76 2.12 1.88 2.7l-.39 1.44s0 .09.04.13c.02.02.06.04.07.04s.06-.02.07-.02l1.64-1.11c.24.04.48.06.74.06 2.23 0 4.04-1.44 4.04-3.19s-1.81-3.23-4.06-3.23z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.99 15.99v2.07h-1.48v-7.62h1.03l.18.48c.31-.31.79-.65 1.55-.65 1.44 0 2.12 1.07 2.12 2.82s-1.05 2.99-2.57 2.99c-.3.02-.52 0-.85-.09zm0-4.32v3.29c.07.02.28.04.48.04 1.05 0 1.46-.74 1.46-1.9 0-1.02-.28-1.62-1.11-1.62-.3 0-.59.07-.83.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30.6 12.6h.83v-.18c0-.61-.35-.89-.94-.89-.46 0-1.03.13-1.51.37l-.41-.98c.52-.37 1.33-.61 2.05-.61 1.4 0 2.18.74 2.18 2.16v3.49h-1.03l-.15-.46c-.59.42-1.14.61-1.62.61-1.07 0-1.68-.65-1.68-1.74 0-1.16.79-1.77 2.29-1.77zm.85 1.94v-1.02h-.68c-.76 0-1.14.28-1.14.81 0 .41.2.61.65.61.41.02.92-.18 1.18-.41z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m37.26 15.38c-.52 1.37-1.13 2.36-2.03 2.92l-.9-.83c.52-.46.9-.9 1.22-1.5l-1.96-5.33 1.46-.39 1.26 4.32 1.24-4.34 1.44.41-1.72 4.74z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKakaoPay);
export default __webpack_public_path__ + "static/media/icon-kakao-pay.e79f80616d7a0863ef0d16042c533988.svg";
export { ForwardRef as ReactComponent };